module.exports = __webpack_public_path__ + "static/media/Screenshot19.28c959fb.jpg";